import type { ChatTool, ToolUseProps } from "../components/Chat/ChatTool";
import { ToolStatus } from "../components/Chat/ToolStatus";

type Input = { step?: string; name?: string };
type Output = { ok?: boolean; name?: string };

function UnpinStepTestHeader({ toolUse, result, interrupted }: ToolUseProps) {
  const input = toolUse.input as Input | null;
  const output = result?.output as Output | undefined;
  const done = !!result && !result.isError;
  const name = output?.name ?? input?.name;

  const text = !done
    ? `Removing step test${name ? ` ${name}` : ""}…`
    : output?.ok === false
      ? "Couldn’t remove step test"
      : `Removed step test${name ? ` ${name}` : ""}`;

  return (
    <ToolStatus
      icon="circle-minus"
      text={text}
      pending={!done && !interrupted}
    />
  );
}

export const unpinStepTest: ChatTool = {
  name: "unpinStepTest",
  Header: UnpinStepTestHeader,
};
